export const useConvertShiftPreferences = () => {
  const convertToFormInitialValues = (preferences) => {
    const values = {};

    if (!preferences) return undefined;

    Object.entries(preferences).forEach(([key, value]) => {
      if (typeof value !== 'object') values[key] = value;

      Object.entries(value).forEach(([valueKey, val]) => {
        values[`${key}__${valueKey}`] = val;
      });
    });

    return values;
  };

  const convertToSubmit = (values) => {
    let payload = {};

    for (const [key, value] of Object.entries(values)) {
      const [field, label] = key.split('__');
      if (field === 'distance') {
        payload[field] = Number(value);
      } else {
        payload = {
          ...payload,
          [field]: {
            ...payload[field],
            [label]: value,
          },
        };
      }
    }

    return payload;
  };

  return { convertToFormInitialValues, convertToSubmit };
};
